import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateSampleDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateSample(
  sampleId: string,
  data: UpdateSampleDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.samples.update(sampleId),
    data,
  );
  return response.data;
}
